module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/AnnualMaximumDailyPrecipitation/Tokyo_AnnualMaximumDailyPrecipitation_MRI_RCP85_End.png";